import { MaterialTableColumn } from 'domain/models/materialColumn'

export const userColumns: readonly MaterialTableColumn[] = [
  { id: 'name', label: 'Nome', minWidth: 170 },
  { id: 'email', label: 'Email', minWidth: 100 },
]
